import React, {Fragment, useRef} from 'react';

import {PopoverBody} from 'reactstrap';
import styled from 'styled-components';

import {StyledPopoverBottomDIV} from 'app/general/bootstrap/utils';
import {PopoverForm, PopoverHeading} from 'app/general/overlays';
import {EditableTagsSelect} from 'app/tags/components/EditableTagsSelect';
import {gt} from 'app/utils/i18n';

import type {OverlayProps} from 'app/general/overlays';
import type {ActionableDocumentType} from 'app/general/types';
import type {DocumentContentType} from 'sweet-types';

interface Props {
  contentType: DocumentContentType;
  overlayProps: OverlayProps;
  objectId: number | string;
  document: ActionableDocumentType;
  onSuccess: (doc?: ActionableDocumentType) => any;
}

export const EditTagsDocumentPopover = ({
  overlayProps,
  document,
  contentType,
  objectId,
  onSuccess,
}: Props): JSX.Element => {
  const refreshPopover = useRef<() => void>(() => undefined);

  const tags =
    document.content_type === 'document'
      ? document.document.tags
      : document.tags;

  return (
    <PopoverForm overlayProps={overlayProps}>
      {({close, refreshPosition}) => {
        // used to refresh the page when toggled.
        refreshPopover.current = refreshPosition;
        return (
          <Fragment>
            <PopoverBody className="m-0 p-0">
              <StyledScrollableContainerDiv className="d-flex flex-column">
                <PopoverHeading>{gt('Edit tags')}</PopoverHeading>
                <div className="m-2">
                  <EditableTagsSelect
                    canCreateTags={true}
                    objectContentType={contentType}
                    objectId={objectId}
                    selected={tags}
                    onChange={(promise) => promise.then(onSuccess)}
                  />
                </div>
              </StyledScrollableContainerDiv>
            </PopoverBody>
            <StyledPopoverBottomDIV>
              <button onClick={close} className="btn btn-link btn-sm">
                <i className="fa fa-times" /> {gt('Close')}
              </button>
            </StyledPopoverBottomDIV>
          </Fragment>
        );
      }}
    </PopoverForm>
  );
};

const StyledScrollableContainerDiv = styled.div`
  max-height: calc(100vh - 200px);
  width: 274px;
`;
